import { silhouetteUrl } from "@unfaithful/client";
import type { Cloak, Sigil } from "@unfaithful/shared";

/** A guest's small shadow portrait, beside their name in a list. */
export function MiniFace({ p }: { p: { sigil: Sigil; cloak: Cloak } }) {
  return <img className="mini-face" src={silhouetteUrl(p.sigil, p.cloak)} alt="" aria-hidden />;
}
